import { render, staticRenderFns } from "./DamagePanel.vue?vue&type=template&id=7d7bcc2b&scoped=true&"
import script from "./DamagePanel.vue?vue&type=script&lang=js&"
export * from "./DamagePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7bcc2b",
  null
  
)

export default component.exports